import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControlLabel, Grid, styled, Switch, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CurrencyJSON, ArchitecturalCode, PriceType, Responsibility, ProductType, Units, getSize, Mounting, getWeight, Shielding, VentType, Network, ConnectionType, VoltageType, DissipationType, ElectricalPhase, PlugType, DrainLocation, GasType, GasLocation, handleUndefined } from "../../../../common/const";
import { useState } from "react";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useSelector } from "react-redux";

const DemoTypo = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: 13
}));

const DemoTypography = styled(Typography)(({ theme }) => ({
  color: '#1565c0',
  fontSize: 13
}));

const DefaultTypo = styled(Typography)(({ theme }) => ({
  color: 'gray',
  fontSize: 8
}));

const DefaultTypo1 = styled(Typography)(({ theme }) => ({
  color: 'red',
  fontSize: 8
}));

const DemoGrid = styled(Grid)(({ theme }) => ({
  border: '1px solid lightgray',
  padding: 10
}));

const HeadingTypo = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  borderBottom: '2px solid #3f51b5',
  marginBottom: 10,
}));

const ProductInformation = ({
  itemData,
  projectData
}) => {
  const { user, roles } = useSelector((state) => state.users);
  const isUser = roles.find((a) => a.id === user?.role_id);
  const [isCatalog, setIsCatalog] = useState(false);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography varaint="body1" style={{ fontWeight: 'bold' }}>Product Information</Typography>
        {isUser?.code !== 'orgGuestUser' && (
          <Box>
            <FormControlLabel control={<Switch onChange={(e) => setIsCatalog(e.target.checked)} />} label="Show Catalog Values" />
            <Button
              variant="outlined"
              color="primary"
              size="small"
              style={{
                textTransform: 'capitalize'
              }}
              startIcon={<OpenInNewIcon />}
              onClick={() => window.open(`/app/catalog/product/ct/${itemData.product_id}`, '_blank')}
            >
              Open In Catalog
            </Button>
          </Box>)}
      </Box>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" style={{ width: '100%' }}>
            <Typography style={{ fontWeight: 'bold' }}>Details</Typography>
            <Box>
              <Typography style={{ fontWeight: 'bold' }}>{`${PriceType?.find((a) => a.value === itemData?.product_data?.price_type)?.name || PriceType?.find((a) => a.value === itemData?.product?.price_type)?.name || '--'} Price ${`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemData?.unit_price ? Intl.NumberFormat('en-IN').format(itemData?.unit_price) : 0}`}`}</Typography>
            </Box>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1" style={{ fontWeight: 'bold' }}>Long Description</Typography>
              <DemoTypography variant="body2">{itemData?.product_data?.description !== undefined ? itemData?.product_data?.description : itemData?.product?.description ? itemData?.product?.description : '--'}</DemoTypography>
              {(isCatalog && itemData?.product_data?.description !== undefined && itemData?.product_data?.description !== itemData?.product?.description) && (
                <Box display="flex" alignItems="center" gap={1}>
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{(itemData?.product?.description || '--')}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              <Box display="flex" alignItems="center" gap={1} mt={1}>
                <DemoTypography variant="body2">Type:</DemoTypography>
                <DemoTypo variant="body2">{(itemData?.product_data?.type !== undefined ? ProductType?.find((a) => a.value === itemData?.product_data?.type)?.name : (ProductType?.find((a) => a.value === itemData?.product?.type)?.name || '--'))}</DemoTypo>
              </Box>
              {(isCatalog && itemData?.product_data?.type !== undefined && itemData?.product_data?.type !== itemData?.product?.type) && (
                <Box display="flex" alignItems="center" gap={1}>
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{(ProductType?.find((a) => a.value === itemData?.product?.type)?.name || '--')}</DefaultTypo1>
                </Box>
              )}
              <Box display="flex" alignItems="center" gap={1}>
                <DemoTypography variant="body2">Furnish Responsibility:</DemoTypography>
                <DemoTypo variant="body2">{(Responsibility?.find((a) => a.value === itemData?.product_data?.furnish_responsibility)?.name || Responsibility?.find((a) => a.value === itemData?.product?.furnish_responsibility)?.name || '--')}</DemoTypo>
              </Box>
              {(isCatalog && (Responsibility?.find((a) => a.value === itemData?.product_data?.furnish_responsibility)?.name !== Responsibility?.find((a) => a.value === itemData?.product?.furnish_responsibility)?.name)) && (
                <Box display="flex" alignItems="center" gap={1}>
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{(Responsibility?.find((a) => a.value === itemData?.product?.furnish_responsibility)?.name || '--')}</DefaultTypo1>
                </Box>
              )}
              <Box display="flex" alignItems="center" gap={1}>
                <DemoTypography variant="body2">Install Responsibility:</DemoTypography>
                <DemoTypo variant="body2">{(Responsibility?.find((a) => a.value === itemData?.product_data?.install_responsibility)?.name || Responsibility?.find((a) => a.value === itemData?.product?.install_responsibility)?.name || '--')}</DemoTypo>
              </Box>
              {(isCatalog && (Responsibility?.find((a) => a.value === itemData?.product_data?.install_responsibility)?.name !== Responsibility?.find((a) => a.value === itemData?.product?.install_responsibility)?.name)) && (
                <Box display="flex" alignItems="center" gap={1}>
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{(Responsibility?.find((a) => a.value === itemData?.product?.install_responsibility)?.name || '--')}</DefaultTypo1>
                </Box>
              )}
              <Box display="flex" alignItems="center" gap={1}>
                <DemoTypography variant="body2">Life Expectancy/Lifespan:</DemoTypography>
                <DemoTypo variant="body2">{(itemData?.product_data?.life_expectancy !== undefined && itemData?.product_data?.life_expectancy !== null) ? `${itemData?.product_data?.life_expectancy} years` : (itemData?.product?.life_expectancy !== undefined && itemData?.product?.life_expectancy !== null) ? `${itemData?.product?.life_expectancy} years` : '--'}</DemoTypo>
              </Box>
              {(isCatalog && itemData?.product_data?.life_expectancy !== undefined && itemData?.product_data?.life_expectancy !== itemData?.product?.life_expectancy) && (
                <Box display="flex" alignItems="center" gap={1}>
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.life_expectancy ? `${itemData?.product?.life_expectancy} years` : '--'}</DefaultTypo1>
                </Box>
              )}
              <Box display="flex" alignItems="center" gap={1}>
                <DemoTypography variant="body2">Lead Time:</DemoTypography>
                <DemoTypo variant="body2">{(itemData?.product_data?.lead_time !== undefined && itemData?.product_data?.lead_time !== null) ? `${itemData?.product_data?.lead_time} days` : (itemData?.product?.lead_time !== undefined && itemData?.product?.lead_time !== null) ? `${itemData?.product?.lead_time} days` : '--'}</DemoTypo>
              </Box>
              {(isCatalog && itemData?.product_data?.lead_time !== undefined && itemData?.product_data?.lead_time !== itemData?.product?.lead_time) && (
                <Box display="flex" alignItems="center" gap={1}>
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{itemData?.product?.lead_time ? `${itemData?.product?.lead_time} days` : '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              <Box display="flex" alignItems="center" gap={1}>
                <DemoTypography variant="body2">Architectural Code:</DemoTypography>
                <DemoTypo variant="body2">{(ArchitecturalCode?.find((a) => a.value === itemData?.product_data?.architectural_code)?.name || ArchitecturalCode?.find((a) => a.value === itemData?.product?.architectural_code)?.name || '--')}</DemoTypo>
              </Box>
              {(isCatalog && itemData?.product_data?.architectural_code !== undefined && (ArchitecturalCode?.find((a) => a.value === itemData?.product_data?.architectural_code)?.name !== ArchitecturalCode?.find((a) => a.value === itemData?.product?.architectural_code)?.name)) && (
                <Box display="flex" alignItems="center" gap={1}>
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{(ArchitecturalCode?.find((a) => a.value === itemData?.product?.architectural_code)?.name || '--')}</DefaultTypo1>
                </Box>
              )}
              <Box display="flex" alignItems="center" gap={1}>
                <DemoTypography variant="body2">Architecturally Significant:</DemoTypography>
                <DemoTypo variant="body2">{itemData?.product_data?.architecturally_significant !== undefined ? (itemData?.product_data?.architecturally_significant ? 'Yes' : 'No') : (itemData?.product?.architecturally_significant ? 'Yes' : 'No')}</DemoTypo>
              </Box>
              {(isCatalog && itemData?.product_data?.architecturally_significant !== undefined && itemData?.product_data?.architecturally_significant !== itemData?.product?.architecturally_significant) && (
                <Box display="flex" alignItems="center" gap={1}>
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{(itemData?.product?.architecturally_significant ? 'Yes' : 'No') || '--'}</DefaultTypo1>
                </Box>
              )}
              <Box display="flex" alignItems="center" gap={1}>
                <DemoTypography variant="body2">Spatially Significant:</DemoTypography>
                <DemoTypo variant="body2">{itemData?.product_data?.spatially_significant !== undefined ? (itemData?.product_data?.spatially_significant ? 'Yes' : 'No') : (itemData?.product?.spatially_significant ? 'Yes' : 'No')}</DemoTypo>
              </Box>
              {(isCatalog && itemData?.product_data?.spatially_significant !== undefined && itemData?.product_data?.spatially_significant !== itemData?.product?.spatially_significant) && (
                <Box display="flex" alignItems="center" gap={1}>
                  <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                  <DefaultTypo1 variant="body2">{(itemData?.product?.spatially_significant ? 'Yes' : 'No') || '--'}</DefaultTypo1>
                </Box>
              )}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography variant="h6" style={{ fontSize: 18 }}>Physical</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container>
            <DemoGrid item xs={12} sm={6} md={3}>
              <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Dimensions</HeadingTypo>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Units:</DemoTypography>
                    <DemoTypo variant="body2">{Units?.find((a) => a.value === projectData?.default_project_units)?.name || '--'}</DemoTypo>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Width:</DemoTypography>
                    <DemoTypo variant="body2">{getSize(projectData?.default_project_units, handleUndefined(itemData?.product_data?.width, itemData?.product?.width)) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.width !== undefined && itemData?.product_data?.width !== itemData?.product?.width) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.width) || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Height:</DemoTypography>
                    <DemoTypo variant="body2">{getSize(projectData?.default_project_units, handleUndefined(itemData?.product_data?.height, itemData?.product?.height)) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.height !== undefined && itemData?.product_data?.height !== itemData?.product?.height) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.height) || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Depth:</DemoTypography>
                    <DemoTypo variant="body2">{getSize(projectData?.default_project_units, handleUndefined(itemData?.product_data?.depth, itemData?.product?.depth)) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.depth !== undefined && itemData?.product_data?.depth !== itemData?.product?.depth) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.depth) || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box>
                    <DemoTypography variant="body2">Spatial Notes:</DemoTypography>
                    <Typography variant="body2" sx={{ fontSize: 12 }}>{itemData?.product_data?.spatial_remarks !== undefined ? itemData?.product_data?.spatial_remarks : (itemData?.product.spatial_remarks || '--')}</Typography>
                  </Box>
                  {(isCatalog && itemData?.product_data?.spatial_remarks !== undefined && itemData?.product_data?.spatial_remarks !== itemData?.product?.spatial_remarks) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product.spatial_remarks || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </DemoGrid>
            <DemoGrid item xs={12} sm={6} md={3}>
              <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Clearance</HeadingTypo>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" gap={1}>
                    <DemoTypography variant="body2">Left:</DemoTypography>
                    <DemoTypo variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.left ? handleUndefined(itemData?.product_data?.clearance?.left, itemData?.product?.clearance?.left) : 0) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.clearance?.left !== undefined && itemData?.product_data?.clearance?.left !== itemData?.product?.clearance?.left) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.left) || '--'}</DefaultTypo1>
                    </Box>
                  )}
                  <Box display="flex" gap={1}>
                    <DemoTypography variant="body2">Right:</DemoTypography>
                    <DemoTypo variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.right ? handleUndefined(itemData?.product_data?.clearance?.right, itemData?.product?.clearance?.right) : 0) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.clearance?.right !== undefined && itemData?.product_data?.clearance?.right !== itemData?.product?.clearance?.right) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.right) || '--'}</DefaultTypo1>
                    </Box>
                  )}
                  <Box display="flex" gap={1}>
                    <DemoTypography variant="body2">Top:</DemoTypography>
                    <DemoTypo variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.top ? handleUndefined(itemData?.product_data?.clearance?.top, itemData?.product?.clearance?.top) : 0) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.clearance?.top !== undefined && itemData?.product_data?.clearance?.top !== itemData?.product?.clearance?.top) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.top) || '--'}</DefaultTypo1>
                    </Box>
                  )}
                  <Box display="flex" gap={1}>
                    <DemoTypography variant="body2">Bottom:</DemoTypography>
                    <DemoTypo variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.bottom ? handleUndefined(itemData?.product_data?.clearance?.bottom, itemData?.product?.clearance?.bottom) : 0) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.clearance?.bottom !== undefined && itemData?.product_data?.clearance?.bottom !== itemData?.product?.clearance?.bottom) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.bottom) || '--'}</DefaultTypo1>
                    </Box>
                  )}
                  <Box display="flex" gap={1}>
                    <DemoTypography variant="body2">Front:</DemoTypography>
                    <DemoTypo variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.front ? handleUndefined(itemData?.product_data?.clearance?.front, itemData?.product?.clearance?.front) : 0) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.clearance?.front !== undefined && itemData?.product_data?.clearance?.front !== itemData?.product?.clearance?.front) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.front) || '--'}</DefaultTypo1>
                    </Box>
                  )}
                  <Box display="flex" gap={1}>
                    <DemoTypography variant="body2">Back:</DemoTypography>
                    <DemoTypo variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.back ? handleUndefined(itemData?.product_data?.clearance?.back, itemData?.product?.clearance?.back) : 0) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.clearance?.back !== undefined && itemData?.product_data?.clearance?.back !== itemData?.product?.clearance?.back) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{getSize(projectData?.default_project_units, itemData?.product?.clearance?.back) || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </DemoGrid>
            <DemoGrid item xs={12} sm={6} md={3}>
              <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Weights</HeadingTypo>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Mouting:</DemoTypography>
                    <DemoTypo variant="body2">{Mounting.find((a) => a.value === handleUndefined(itemData?.product_data?.mounting, itemData?.product?.mounting))?.name || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.mounting !== undefined && itemData?.product_data?.mounting !== itemData?.product?.mounting) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{Mounting.find((a) => a.value === itemData?.product?.mounting)?.name || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Product Weight:</DemoTypography>
                    <DemoTypo variant="body2">{getWeight(projectData?.default_project_units, handleUndefined(itemData?.product_data?.max_weight, itemData?.product?.max_weight)) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.max_weight !== undefined && itemData?.product_data?.max_weight !== itemData?.product?.max_weight) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{getWeight(projectData?.default_project_units, itemData?.product?.max_weight) || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Ship Weight:</DemoTypography>
                    <DemoTypo variant="body2">{getWeight(projectData?.default_project_units, handleUndefined(itemData?.product_data?.ship_weight, itemData?.product?.ship_weight)) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.ship_weight !== undefined && itemData?.product_data?.ship_weight !== itemData?.product?.ship_weight) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{getWeight(projectData?.default_project_units, itemData?.product?.ship_weight) || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </DemoGrid>
            <DemoGrid item xs={12} sm={6} md={3}>
              <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Attributes</HeadingTypo>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">DA Compliant:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.da_complient !== undefined ? itemData?.product_data?.da_complient ? 'Yes' : 'No' : itemData?.product?.da_complient ? 'Yes' : 'No'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.da_complient !== undefined && itemData?.product_data?.da_complient !== itemData?.product?.da_complient) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.da_complient ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Anti-Microbial:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.antimicrobial !== undefined ? itemData?.product_data?.antimicrobial ? 'Yes' : 'No' : itemData?.product?.antimicrobial ? 'Yes' : 'No'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.antimicrobial !== undefined && itemData?.product_data?.antimicrobial !== itemData?.product?.antimicrobial) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.antimicrobial ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Green:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.green !== undefined ? itemData?.product_data?.green ? 'Yes' : 'No' : itemData?.product?.green ? 'Yes' : 'No'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.green !== undefined && itemData?.product_data?.green !== itemData?.product?.green) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.green ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Shielding:</DemoTypography>
                    <DemoTypo variant="body2">{Shielding?.find((a) => a.value === handleUndefined(itemData?.product_data?.Shielding, itemData?.product?.Shielding))?.name || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.Shielding !== undefined && itemData?.product_data?.Shielding !== itemData?.product?.Shielding) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{Shielding?.find((a) => a.value === itemData?.product?.Shielding)?.name || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Seismic:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.seismic !== undefined ? itemData?.product_data?.seismic ? 'Yes' : 'No' : itemData?.product?.seismic ? 'Yes' : 'No'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.seismic !== undefined && itemData?.product_data?.seismic !== itemData?.product?.seismic) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.seismic ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </DemoGrid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          <Typography variant="h6" style={{ fontSize: 18 }}>Utilites</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container>
            <DemoGrid item xs={12} sm={6} md={3}>
              <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Mechanical</HeadingTypo>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Vent:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.mechanical_data?.vent !== undefined ? itemData?.product_data?.mechanical_data?.vent ? 'Yes' : 'No' : itemData?.product?.mechanical_data?.vent ? 'Yes' : 'No'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.mechanical_data?.vent !== undefined && itemData?.product_data?.mechanical_data?.vent !== itemData?.product?.mechanical_data?.vent) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.mechanical_data?.vent ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">VentType:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.mechanical_data?.vent !== undefined ? (VentType?.find((a) => a.value === itemData?.product_data?.mechanical_data?.ventType)?.name || '--') : itemData?.product?.mechanical_data?.vent ? (VentType?.find((a) => a.value === itemData?.product?.mechanical_data?.ventType)?.name || '--') : '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.mechanical_data?.ventType !== undefined && itemData?.product_data?.mechanical_data?.ventType !== itemData?.product?.mechanical_data?.ventType) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{VentType?.find((a) => a.value === itemData?.product?.mechanical_data?.ventType)?.name || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Heat Dissipation (BTU/hr):</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.mechanical_data?.heatDissipation !== undefined ? `${itemData?.product_data?.mechanical_data?.heatDissipation} BTUs/hr` : itemData?.product?.mechanical_data?.heatDissipation ? `${itemData?.product?.mechanical_data?.heatDissipation} BTUs/hr` : '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.mechanical_data?.heatDissipation !== undefined && itemData?.product_data?.mechanical_data?.heatDissipation !== itemData?.product?.mechanical_data?.heatDissipation) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.mechanical_data?.heatDissipation ? `${itemData?.product?.mechanical_data?.heatDissipation} BTUs/hr` : '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Dissipation Type:</DemoTypography>
                    <DemoTypo variant="body2">{DissipationType.find((a) => a.value === handleUndefined(itemData?.product_data?.mechanical_data?.dissipationType, itemData?.product?.mechanical_data?.dissipationType))?.name || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.mechanical_data?.dissipationType !== undefined && itemData?.product_data?.mechanical_data?.dissipationType !== itemData?.product?.mechanical_data?.dissipationType) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{DissipationType.find((a) => a.value === itemData?.product?.mechanical_data?.dissipationType)?.name || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box>
                    <DemoTypography variant="body2">Notes:</DemoTypography>
                    <Typography variant="body2" sx={{ fontSize: 12 }}>{handleUndefined(itemData?.product_data?.mechanical_data?.mechanicalRemarks, itemData?.product?.mechanical_data?.mechanicalRemarks) || '--'}</Typography>
                  </Box>
                  {(isCatalog && itemData?.product_data?.mechanical_data?.mechanicalRemarks !== undefined && itemData?.product_data?.mechanical_data?.mechanicalRemarks !== itemData?.product?.mechanical_data?.mechanicalRemarks) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.mechanical_data?.mechanicalRemarks || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </DemoGrid>
            <DemoGrid item xs={12} sm={6} md={3}>
              <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Electrical</HeadingTypo>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Voltage Type:</DemoTypography>
                    <DemoTypo variant="body2">{VoltageType.find((a) => a.value === handleUndefined(itemData?.product_data?.electrical_data?.voltageType, itemData?.product?.electrical_data?.voltageType))?.name || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.voltageType !== undefined && itemData?.product_data?.electrical_data?.voltageType !== itemData?.product?.electrical_data?.voltageType) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{VoltageType.find((a) => a.value === itemData?.product?.electrical_data?.voltageType)?.name || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Volts:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.electrical_data?.volts !== undefined ? `${itemData?.product_data?.electrical_data?.volts} V` : itemData?.product?.electrical_data?.volts ? `${itemData?.product?.electrical_data?.volts} V` : '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.volts !== undefined && itemData?.product_data?.electrical_data?.volts !== itemData?.product?.electrical_data?.volts) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.volts ? `${itemData?.product?.electrical_data?.volts} V` : '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Amps:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.electrical_data?.amps !== undefined ? `${itemData?.product_data?.electrical_data?.amps} A` : itemData?.product?.electrical_data?.amps ? `${itemData?.product?.electrical_data?.amps} A` : '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.amps !== undefined && itemData?.product_data?.electrical_data?.amps !== itemData?.product?.electrical_data?.amps) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.amps ? `${itemData?.product?.electrical_data?.amps} A` : '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Watts:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.electrical_data?.watts !== undefined ? `${itemData?.product_data?.electrical_data?.watts} W` : itemData?.product?.electrical_data?.watts ? `${itemData?.product?.electrical_data?.watts} W` : '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.watts !== undefined && itemData?.product_data?.electrical_data?.watts !== itemData?.product?.electrical_data?.watts) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.watts ? `${itemData?.product?.electrical_data?.watts} W` : '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">kVA:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.electrical_data?.kva !== undefined ? `${itemData?.product_data?.electrical_data?.kva} kVA` : itemData?.product?.electrical_data?.kva ? `${itemData?.product?.electrical_data?.kva} kVA` : '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.kva !== undefined && itemData?.product_data?.electrical_data?.kva !== itemData?.product?.electrical_data?.kva) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.kva ? `${itemData?.product?.electrical_data?.kva} kVA` : '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Hertz:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.electrical_data?.hertz !== undefined ? `${itemData?.product_data?.electrical_data?.hertz} Hz` : itemData?.product?.electrical_data?.hertz ? `${itemData?.product?.electrical_data?.hertz} Hz` : '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.hertz !== undefined && itemData?.product_data?.electrical_data?.hertz !== itemData?.product?.electrical_data?.hertz) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.hertz ? `${itemData?.product?.electrical_data?.hertz} Hz` : '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Phase:</DemoTypography>
                    <DemoTypo variant="body2">{ElectricalPhase.find((a) => a.value === handleUndefined(itemData?.product_data?.electrical_data?.electricalPhase, itemData?.product?.electrical_data?.electricalPhase))?.name || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.electricalPhase !== undefined && itemData?.product_data?.electrical_data?.electricalPhase !== itemData?.product?.electrical_data?.electricalPhase) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{ElectricalPhase.find((a) => a.value === itemData?.product?.electrical_data?.electricalPhase)?.name || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Plug Type:</DemoTypography>
                    <DemoTypo variant="body2">{PlugType.find((a) => a.value === handleUndefined(itemData?.product_data?.electrical_data?.plugtype, itemData?.product?.electrical_data?.plugtype))?.name || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.plugtype !== undefined && itemData?.product_data?.electrical_data?.plugtype !== itemData?.product?.electrical_data?.plugtype) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{PlugType.find((a) => a.value === itemData?.product?.electrical_data?.plugtype)?.name || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" gap={1}>
                    <DemoTypography variant="body2">Plug Details:</DemoTypography>
                    <DemoTypo variant="body2">{handleUndefined(itemData?.product_data?.electrical_data?.plugdetail, itemData?.product?.electrical_data?.plugdetail) || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.plugdetail !== undefined && itemData?.product_data?.electrical_data?.plugdetail !== itemData?.product?.electrical_data?.plugdetail) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.plugdetail || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Dedicated Circuit:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.electrical_data?.dedicatedCircuit !== undefined ? (itemData?.product_data?.electrical_data?.dedicatedCircuit ? 'Manufacturer Recommended' : 'No') : (itemData?.product?.electrical_data?.dedicatedCircuit ? 'Manufacturer Recommended' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.dedicatedCircuit !== undefined && itemData?.product_data?.electrical_data?.dedicatedCircuit !== itemData?.product?.electrical_data?.dedicatedCircuit) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.dedicatedCircuit ? 'Manufacturer Recommended' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Emergency Power:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.electrical_data?.emergencyPower !== undefined ? (itemData?.product_data?.electrical_data?.emergencyPower ? 'Yes' : 'No') : (itemData?.product?.electrical_data?.emergencyPower ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.emergencyPower !== undefined && itemData?.product_data?.electrical_data?.emergencyPower !== itemData?.product?.electrical_data?.emergencyPower) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.emergencyPower ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Remote Transformer:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.electrical_data?.remoteTrans !== undefined ? (itemData?.product_data?.electrical_data?.remoteTrans ? 'Yes' : 'No') : (itemData?.product?.electrical_data?.remoteTrans ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.remoteTrans !== undefined && itemData?.product_data?.electrical_data?.remoteTrans !== itemData?.product?.electrical_data?.remoteTrans) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.remoteTrans ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Remote Switch/Controller:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.electrical_data?.remoteSwitch !== undefined ? (itemData?.product_data?.electrical_data?.remoteSwitch ? 'Yes' : 'No') : (itemData?.product?.electrical_data?.remoteSwitch ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.remoteSwitch !== undefined && itemData?.product_data?.electrical_data?.remoteSwitch !== itemData?.product?.electrical_data?.remoteSwitch) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.remoteSwitch ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box>
                    <DemoTypography variant="body2">Notes:</DemoTypography>
                    <Typography variant="body2" sx={{ fontSize: 12 }}>{handleUndefined(itemData?.product_data?.electrical_data?.electricalRemarks, itemData?.product?.electrical_data?.electricalRemarks) || '--'}</Typography>
                  </Box>
                  {(isCatalog && itemData?.product_data?.electrical_data?.electricalRemarks !== undefined && itemData?.product_data?.electrical_data?.electricalRemarks !== itemData?.product?.electrical_data?.electricalRemarks) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.electrical_data?.electricalRemarks || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </DemoGrid>
            <DemoGrid item xs={12} sm={6} md={3}>
              <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Plumbing</HeadingTypo>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Water Cold:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.plumbing_data?.coldWater !== undefined ? (itemData?.product_data?.plumbing_data?.coldWater ? 'Yes' : 'No') : (itemData?.product?.plumbing_data?.coldWater ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.coldWater !== undefined && itemData?.product_data?.plumbing_data?.coldWater !== itemData?.product?.plumbing_data?.coldWater) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.coldWater ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Water Hot:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.plumbing_data?.hotWater !== undefined ? (itemData?.product_data?.plumbing_data?.hotWater ? 'Yes' : 'No') : (itemData?.product?.plumbing_data?.hotWater ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.hotWater !== undefined && itemData?.product_data?.plumbing_data?.hotWater !== itemData?.product?.plumbing_data?.hotWater) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.hotWater ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Water Treated:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.plumbing_data?.treatedWater !== undefined ? (itemData?.product_data?.plumbing_data?.treatedWater ? 'Yes' : 'No') : (itemData?.product?.plumbing_data?.treatedWater ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.treatedWater !== undefined && itemData?.product_data?.plumbing_data?.treatedWater !== itemData?.product?.plumbing_data?.treatedWater) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.treatedWater ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Steam:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.plumbing_data?.steam !== undefined ? (itemData?.product_data?.plumbing_data?.steam ? 'Yes' : 'No') : (itemData?.product?.plumbing_data?.steam ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.steam !== undefined && itemData?.product_data?.plumbing_data?.steam !== itemData?.product?.plumbing_data?.steam) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.steam ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Vaccum-Medical:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.plumbing_data?.vaccumMedical !== undefined ? (itemData?.product_data?.plumbing_data?.vaccumMedical ? 'Yes' : 'No') : (itemData?.product?.plumbing_data?.vaccumMedical ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.vaccumMedical !== undefined && itemData?.product_data?.plumbing_data?.vaccumMedical !== itemData?.product?.plumbing_data?.vaccumDental) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.vaccumMedical ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Vaccum-Dental:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.plumbing_data?.vaccumDental !== undefined ? (itemData?.product_data?.plumbing_data?.vaccumDental ? 'Yes' : 'No') : (itemData?.product?.plumbing_data?.vaccumDental ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.vaccumDental !== undefined && itemData?.product_data?.plumbing_data?.vaccumDental !== itemData?.product?.plumbing_data?.vaccumDental) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.vaccumDental ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Drain:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.plumbing_data?.drain !== undefined ? (itemData?.product_data?.plumbing_data?.drain ? 'Yes' : 'No') : (itemData?.product?.plumbing_data?.drain ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.drain !== undefined && itemData?.product_data?.plumbing_data?.drain !== itemData?.product?.plumbing_data?.drain) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.drain ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Drain Location:</DemoTypography>
                    <DemoTypo variant="body2">{DrainLocation.find((a) => a.value === handleUndefined(itemData?.product_data?.plumbing_data?.drainLocation, itemData?.product?.plumbing_data?.drainLocation))?.name || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.drainLocation !== undefined && itemData?.product_data?.plumbing_data?.drainLocation !== itemData?.product?.plumbing_data?.drainLocation) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{DrainLocation.find((a) => a.value === itemData?.product?.plumbing_data?.drainLocation)?.name || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Medical Gas:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.plumbing_data?.medicalGas !== undefined ? (itemData?.product_data?.plumbing_data?.medicalGas ? 'Yes' : 'No') : (itemData?.product?.plumbing_data?.medicalGas ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.medicalGas !== undefined && itemData?.product_data?.plumbing_data?.medicalGas !== itemData?.product?.plumbing_data?.medicalGas) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.medicalGas ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" gap={1}>
                    <DemoTypography variant="body2">Gas Type:</DemoTypography>
                    <DemoTypo variant="body2">
                      {(itemData?.product_data?.plumbing_data?.gasType?.length > 0 && itemData?.product_data?.plumbing_data?.gasType !== undefined) ?
                        GasType.filter((a) => itemData?.product?.plumbing_data?.gasType?.includes(a.value))
                          .map((a, index) => (
                            <span key={index}>
                              {a.name}
                              <br />
                            </span>
                          ))
                        : itemData?.product?.plumbing_data?.gasType?.length > 0
                          ? GasType.filter((a) => itemData?.product?.plumbing_data?.gasType?.includes(a.value))
                            .map((a, index) => (
                              <span key={index}>
                                {a.name}
                                <br />
                              </span>
                            ))
                          : '--'}
                    </DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.gasType !== undefined && JSON.stringify(itemData?.product_data?.plumbing_data?.gasType) !== JSON.stringify(itemData?.product?.plumbing_data?.gasType)) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.gasType?.length > 0
                        ? GasType.filter((a) => itemData?.product?.plumbing_data?.gasType?.includes(a.value))
                          .map((a, index) => (
                            <span key={index}>
                              {a.name}
                              <br />
                            </span>
                          ))
                        : '--'}
                      </DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Gas Location:</DemoTypography>
                    <DemoTypo variant="body2">{GasLocation.find((a) => a.value === handleUndefined(itemData?.product_data?.plumbing_data?.gasLocation, itemData?.product?.plumbing_data?.gasLocation))?.name || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.gasLocation !== undefined && itemData?.product_data?.plumbing_data?.gasLocation !== itemData?.product?.plumbing_data?.gasLocation) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{GasLocation.find((a) => a.value === itemData?.product?.plumbing_data?.gasLocation)?.name || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box >
                    <DemoTypography variant="body2">Notes:</DemoTypography>
                    <Typography variant="body2" sx={{ fontSize: 12 }}>{handleUndefined(itemData?.product_data?.plumbing_data?.plumbingRemarks, itemData?.product?.plumbing_data?.plumbingRemarks) || '--'}</Typography>
                  </Box>
                  {(isCatalog && itemData?.product_data?.plumbing_data?.plumbingRemarks !== undefined && itemData?.product_data?.plumbing_data?.plumbingRemarks !== itemData?.product?.plumbing_data?.plumbingRemarks) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.plumbing_data?.plumbingRemarks || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </DemoGrid>
            <DemoGrid item xs={12} sm={6} md={3}>
              <HeadingTypo variant="h6" style={{ fontSize: 16 }}>Tech Connection</HeadingTypo>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Has Technical Connection:</DemoTypography>
                    <DemoTypo variant="body2">{itemData?.product_data?.tech_connection_data?.isConnection !== undefined ? (itemData?.product_data?.tech_connection_data?.isConnection ? 'Yes' : 'No') : (itemData?.product?.tech_connection_data?.isConnection ? 'Yes' : 'No')}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.tech_connection_data?.isConnection !== undefined && itemData?.product_data?.tech_connection_data?.isConnection !== itemData?.product?.tech_connection_data?.isConnection) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.tech_connection_data?.isConnection ? 'Yes' : 'No'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">ConnectionType:</DemoTypography>
                    <DemoTypo variant="body2">{ConnectionType?.find((a) => a.value === handleUndefined(itemData?.product_data?.tech_connection_data?.connectionType, itemData?.product?.tech_connection_data?.connectionType))?.name || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.tech_connection_data?.connectionType !== undefined && itemData?.product_data?.tech_connection_data?.connectionType !== itemData?.product?.tech_connection_data?.connectionType) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{ConnectionType?.find((a) => a.value === itemData?.product?.tech_connection_data?.connectionType)?.name || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <DemoTypography variant="body2">Network:</DemoTypography>
                    <DemoTypo variant="body2">{Network.find((a) => a.value === handleUndefined(itemData?.product_data?.tech_connection_data?.network, itemData?.product?.tech_connection_data?.network))?.name || '--'}</DemoTypo>
                  </Box>
                  {(isCatalog && itemData?.product_data?.tech_connection_data?.network !== undefined && itemData?.product_data?.tech_connection_data?.network !== itemData?.product?.tech_connection_data?.network) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{Network?.find((a) => a.value === itemData?.product?.tech_connection_data?.network)?.name || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box>
                    <DemoTypography variant="body2">Notes:</DemoTypography>
                    <Typography variant="body2" sx={{ fontSize: 12 }}>{handleUndefined(itemData?.product_data?.tech_connection_data?.techRemarks, itemData?.product?.tech_connection_data?.techRemarks) || '--'}</Typography>
                  </Box>
                  {(isCatalog && itemData?.product_data?.tech_connection_data?.techRemarks !== undefined && itemData?.product_data?.tech_connection_data?.techRemarks !== itemData?.product?.tech_connection_data?.techRemarks) && (
                    <Box display="flex" alignItems="center" gap={1}>
                      <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                      <DefaultTypo1 variant="body2">{itemData?.product?.tech_connection_data?.techRemarks || '--'}</DefaultTypo1>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </DemoGrid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>
  )
};

export default ProductInformation;